import type { Step } from "@k8slens/lds-tips/lib/es/Tips/Steps";

import { TipContent } from "./TipContent";

import styles from "./Tip.module.css";

export const stepId = "manage-seats";
export const targetId = `${stepId}-step`;

export const step: Step = {
  id: stepId,
  selector: `#${targetId}`,
  theme: "important",
  pointerClassName: styles.pointer,
  popupClassName: styles.popup,
  placement: "right-end",
  pointerOffset: [
    -28,
    -10
  ],
  content: (
    <TipContent
      title="Manage Seats For Your Team!"
      content={[
        "After creating a Subscription you should assign your team Members to its seats. Go here to get started assigning and managing seats  for your team.",
        "You can always find and manage your subscription seats from here or the left hand side menu."
      ]}
    />
  )
};
